<template>
  <v-container max-width="1200">
    <v-card class="pa-4 align-center justify-center">
      <v-card-text>
        <div v-show="filtered_images.length != 0 && filtered_images[currentIndex].video == '' || showImage">
          <Splide :options="
            { 
              arrows: false, 
              rewind: true, 
              pagination: 
              false, 
              type: 'fade', 
              speed: 0,
              autoHeight: true, 
            }" 
            aria-label="Vue Splide Example" ref="main" class="main">
            <SplideSlide v-for="image in filtered_images" v-bind:key="image.id" style="justify-content: center;display: flex;">
              <img 
                :src="'https://aurorafinder.app/api/aurora_image/' + image.image_name" 
                onerror="this.onerror=null;this.src='https://placehold.co/968x563/000000/FFF?text=No+Image/Video+Available';" 
                alt="No Image">
            </SplideSlide>
          </Splide>
        </div>

        <div v-show="showVideo && !showImage" id="wrapper">
          
          <vue-plyr ref="plyr">
            <div class="plyr__video-embed">
              <iframe id="iframe"
                :src="src"
                allowfullscreen
                allowtransparency
                allow="autoplay"
              ></iframe>
              <div v-if="this.currentLive" class="text"><h1>LIVE</h1></div>
            </div>
          </vue-plyr>
        </div>

        <Splide class="mt-4 thumbnail" :options="
          { 
            arrows: true,
            speed: 100,
            rewind: true, 
            fixedWidth: 100, 
            fixedHeight: 60, 
            gap: 0, 
            pagination: false,
            isNavigation: true,
            focus: 'center',
            breakpoints: {
              600: {
                fixedWidth : 60,
                fixedHeight: 44,
              },
            },
          }" 
          aria-label="Vue Splide Example" ref="thumbnail"
          @splide:active="updateCurrent">
          <SplideSlide v-for="image in filtered_images" v-bind:key="image">
            <img :src="'https://aurorafinder.app/api/aurora_image/' + image.image_name" 
            @click="set_timestamp(image)"
            onerror="this.onerror=null;this.src='https://placehold.co/968x563/000000/FFF?text=No+Image/Video+Available';" 
            alt="No Image">
          </SplideSlide>
        </Splide>
      </v-card-text>
    </v-card>

    <v-row class="pt-4 justify-center">
      <v-col>
        <v-card class="pa-4 d-flex align-center justify-center fill-height"  >
          <v-row>
            <v-col cols="12">
              <v-select
                label="Only Show"
                :items="filter_items"
                v-model="filter"
                @update:model-value="filterTier"
                item-title="name"
                item-value="tiers"
              ></v-select>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-4 d-flex align-center justify-center fill-height">
          <v-card-text v-if="filtered_images.length > 0">
            <!-- <p>ID: {{ filtered_images[currentIndex].id }}</p>
            <p>Name: {{ filtered_images[currentIndex].image_name }}</p> -->
            <p>Date Received: {{ filtered_images[currentIndex].timestamp }}</p>
            <p>Tier: {{ convertTier(filtered_images[currentIndex].tier) }}</p>
            <!-- <p>Live: {{ currentLive }}</p> -->
            <!-- <p>Test Timestamp: {{ filtered_images[currentIndex].timestamp }}</p>
            <p>Test Live: {{ filtered_images[currentIndex].live }}</p>
            <p>Test Video ID: {{ filtered_images[currentIndex].video }}</p> -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-4 d-flex align-center justify-center fill-height">
          <NotificationPage />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import NotificationPage from './NotificationPage.vue';
import { useMainStore } from '@/store/store';
import { mapState } from 'pinia'

export default {
  setup() {
    const store = useMainStore()

    return { store }
  },
  name: 'ImageCarousel',

  components: {  
    Splide, 
    SplideSlide,
    VuePlyr,
    NotificationPage,
  },

  data: () => ({
    currentIndex: 0,
    selected_tier: null,
    all_images: [],
    filtered_images: [],
    filter_items: [
      { name: 'All', tiers: '-2-101234', },
      { name: 'Subdued and Higher', tiers: '1234' },
      { name: 'Engaging and Higher', tiers: '234' },
      { name: 'Vivid and Higher', tiers: '34', },
      { name: 'Brilliant', tiers: '4', },
    ],
    filter: 'All',
    timestamp: 0,
    current_videoId: '',
    currentLive: false,
    currentDuration: null,
    loaded: false,
    timer: null,
    src: "https://youtube.com/embed/",
    showImage: false
  }),
  computed: {
    showVideo() {
      return this.filtered_images.length != 0 && this.filtered_images[this.currentIndex].video != ''
    },
    ...mapState(useMainStore, {
      userToken: store => store.token,
      user: store => store.user,
      isLoggedIn: store => store.isLoggedIn,
    })
  },
  mounted() {
    // console.log(this.isLoggedIn)
    this.$refs.plyr.player.poster = '/loading.jpg'
    this.$refs.plyr.player.autoplay = false
    this.$refs.plyr.player.on('pause', () => {
      this.currentDuration = this.$refs.plyr.player.embed.getDuration()
      this.currentLive = this.$refs.plyr.player.embed.getVideoData().isLive
      // console.log(this.currentDuration)
    })
    this.$refs.plyr.player.on('statechange', (event) => {
      if (event.detail.code === 3 && !this.loaded) {
        // this.currentDuration = this.$refs.plyr.player.embed.getDuration()

        this.currentDuration = this.$refs.plyr.player.embed.getCurrentTime()
        this.currentLive = this.$refs.plyr.player.embed.getVideoData().isLive

        if (this.currentDuration > 0) {
          var seek = 0
          this.$refs.plyr.player.muted = true;
          this.$refs.plyr.player.volume = 0

          // Handles live video
          if (this.currentLive) {
            seek = (Math.abs(this.time_available - (this.timestamp.getTime() / 1000) + 5))
            if (seek <= 0) { seek = 1 }
            
            this.loaded = true
            this.$refs.plyr.player.play()
          }
        }
      }
    })
    this.$refs.main.splide.sync(this.$refs.thumbnail.splide)
    this.$refs.plyr.player.on('ready', () => {
      this.retrieveImages()
    })
    
    // this.timer = setInterval(() => {
    //   this.retrieveImages()
    // }, 5000)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
      convertTier(tier) {
        switch(tier) {
            case "0":
                return "No Aurora"
            case "1":
                return "Subdued"
            case "2":
                return "Engaging"
            case "3":
                return "Vivid"
            case "4":
                return "Brilliant"
            case "-1":
                return "Cloud Obstructions"
            case "-2":
                return "Cloud Obstructions With Aurora"
            case "-3":
                return "Light Contamination"
        }
    },
    retrieveImages() {
        this.currentIndex = 0
        this.all_images = []
        // fetch('https://aurorafinder.app/api/images/'+ this.selected_tier +'/')
        fetch('https://aurorafinder.app/api/images/')
        .then((resp) => resp.json())
        .then((data) => {
          this.all_images = data
          // var timestamp = 0
          this.all_images.forEach((image) => {
            image.video = image.video_url
            image.timestamp = new Date (image.date_received)
            image.timestamp.setHours(image.timestamp.getHours() - (image.timestamp.getTimezoneOffset() / 60))
          })
          
          this.filtered_images = this.all_images
          
        })
    },
    updateCurrent(image) {
      var seek = 0
      this.currentIndex = image.index
      if (this.showVideo) {
        this.timestamp = this.filtered_images[this.currentIndex].timestamp
        this.time_available = this.filtered_images[this.currentIndex].time_available
        this.loaded = false
        
        var new_videoId = this.filtered_images[this.currentIndex].video

        this.$refs.plyr.player.muted = true;
        this.$refs.plyr.player.volume = 0

        // Handles non-live video
        seek = (Math.abs(this.time_available - (this.timestamp.getTime() / 1000) + 15))
        if (seek <= 0) { seek = 1 }

        // Check if video is different, load if different
        if (this.current_videoId != new_videoId) {
          this.showImage = false
          this.current_videoId = new_videoId
          this.$refs.plyr.player.embed.loadVideoById(this.filtered_images[this.currentIndex].video, seek)
          this.$refs.plyr.player.play()
        }
        else {
          if (seek > this.$refs.plyr.player.duration) {
            this.showImage = true
          }
          else {
            this.showImage = false
            this.$refs.plyr.player.currentTime = seek
            this.$refs.plyr.player.play()
          }
        }
        
      }
      else {
        this.$refs.plyr.player.stop()
      }
    },
    filterTier() {
      
      // Store id of currently viewed image
      if (this.filtered_images.length > 0) {
        var current_id = this.filtered_images[this.currentIndex].id
      }
      
      // Filter images
      this.filtered_images = this.all_images.filter((image) => this.filter.includes(image.tier))

      // Find current image in filtered list
      var new_index = this.filtered_images.findIndex((image) => {
        return image.id == current_id
      })
      
      // If image is still in list, keep in current view
      if ((new_index != -1)) {
        this.currentIndex = new_index
        this.$refs.main.splide.go(new_index)
        this.$refs.thumbnail.splide.go(new_index)
      }
      else {
        this.currentIndex = 0
      }
    },
    set_timestamp(image) {

      // If currently viewed image is clicked again, otherwise let splide:active event handle it
      if(this.timestamp == image.timestamp) {
        var seek = 0
        this.$refs.plyr.player.muted = true
        this.$refs.plyr.player.volume = 0

        if (this.currentLive) {
          seek = (Math.abs(image.time_available - (image.timestamp.getTime() / 1000) + 5))
          if (seek <= 0) { seek = 1 }
        }
        else {
          seek = (Math.abs(image.time_available - (image.timestamp.getTime() / 1000) + 15))
        }
        this.showImage = false
        this.$refs.plyr.player.currentTime = seek
        
      }
    },
  },
}
</script>

<style>

/* Uncomment for auto slide height */
/* .splide__list {
  align-items: flex-start;
}

.splide__slide:not(.is-active) {
  height: 0;
} */

.splide {
  max-width: 1000px;
  margin:auto;
  padding:auto;
}

.main .splide__slide img {
  max-width: 1000px;
  max-height: 563px;
  object-fit: cover;
  display: block;
  overflow: hidden;
}

.thumbnail .splide__slide img {
  width: 100%;
  height: 100%;
  border-color: coral;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.thumbnail .splide__slide {
  opacity: 0.6;
  border: none !important;
}

.thumbnail .splide__slide.is-active {
  opacity: 1;
  border: none !important;
  border-bottom: medium solid #1ac266 !important;
}

.plyr__video-embed iframe {
	top: -50%;
	height: 200%;
}

.plyr {
  height: 563px;
  width:100%;
  max-width: 1000px;
  --plyr-color-main: #1ac266;
}
#wrapper{
  position: relative;
  justify-content: center;
  display: flex;
}
#wrapper video{
  position: relative;
  z-index: 100;
}
#wrapper h1{
  position: absolute;
  display: block;
  z-index: 150;
  left: 20px;
  top: 10px;
}
/* .plyr.plyr--loading::after {
  content: "Loading...";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #FFFFFF;
  font-size: 20px;
  z-index: 10;
} */
</style>